import {LogoutTrigger} from "../../enums";
import tld from "../../../../tld";

export default function redirectToSignIn(logoutTrigger?: LogoutTrigger) {
    const param = logoutTrigger === LogoutTrigger.TIMEOUT ? "?timeout=true" : "";
    window.location.href = tld(process.env.REACT_APP_URL_APP_SIGNIN)! + param;
}
